import { getFetch, postFetch } from '@/service/common'
import Vue from 'vue'
import Vuex from 'vuex'
import Cookie from 'js-cookie'
import moment from 'moment'
import { transformBidType } from '@/utils/fun'

Vue.use(Vuex)

const initState = () => ({
	userInfo: {},
	isLogin: false,
	applyStatus: -2, // 申请状态： -2待提交   -1审核失败    0待审核  8审核成功
	bidType: 0, // 入驻类型: 2-POP店铺  3-一件代发店铺  4-供应商经销  5-供应商代销  6-境外pop店铺 7-个体工商户
	step: 1, // 当前入驻步骤
	serverTime: moment(), // 服务器时间
	coopChannel: 1,
	kefuChannel: -1,
})

export default new Vuex.Store({
	state: initState(),
	mutations: {
		reset(state) {
			Object.assign(state, initState())
		},
		setState(state, value) {
			Object.assign(state, value)
		},
		setUserInfo(state, data) {
			state.userInfo = data
		},
		setLogin(state, data) {
			state.isLogin = data
		},
		setBidType(state, value) {
			console.log(
				'🚀 ~ file: index.ts ~ line 36 ~ setBidType ~ value',
				value
			)
			state.bidType = value
		},
		setChannel(state, value) {
			state.coopChannel = value
		},
		setApplyStatus(state, value) {
			state.applyStatus = value
		},
		setStep(state, value) {
			state.step = value
		},
		back(state) {
			if (state.step === 5 && state.coopChannel === 2) {
				state.step = state.step - 2
			} else {
				state.step--
			}
		},
		forward(state) {
			if (state.step === 3 && state.coopChannel === 2) {
				state.step = state.step + 2
			} else {
				state.step++
			}
		},
		setServerTime(state, value) {
			state.serverTime = moment(value && value * 1000)
		},
		setKefuChannel(state, value) {
			state.kefuChannel = value
		}
	},
	actions: {
		async fetchUserInfo({ commit }) {
			try {
				const { code, data }: any = await getFetch('loginInfo')
				if (code === 0) {
					const step = data.cur_step
					commit('setLogin', true)
					commit('setUserInfo', data)
					commit('setBidType', transformBidType(data) || 0)
					commit('setChannel', data.coop_channel || 1)
					commit('setApplyStatus', data.apply_status)
					commit('setStep', step) // 后台返回的当前步骤并不包含‘阅读入驻协议’这一步
					commit('setServerTime', data.server_time) // unix时间戳
					return data
				}
			} catch (error) {
				console.log(error)
			}
		},
		async fetchLogout({ commit }, callback) {
			try {
				const { code }: any = await postFetch('logout')
				if (code === 0) {
					commit('reset')
					Cookie.remove('userId')
					Cookie.remove('accessToken')
					callback()
				}
			} catch (error) {
				console.log(error)
			}
		},
	},
	modules: {},
})
